module.exports = __webpack_public_path__ + "static/media/login-shape-secondary-nick.1b7134e0.png";